<form class="entity-editor" [formGroup]="entityForm">
  <ng-container *ngIf="entityType">
    <ng-container *ngFor="let groupType of entityType.Groups">
      <app-entity-group
        *ngIf="entity.Groups[groupType.Key].Rules.VisibleIf !== false"
        [entity]="entity"
        [groupType]="groupType"
        [entityForm]="entityForm"
        [propertyEditorComponent]="multiEditPropertyComponent"
        (propertyChange)="propertyChanged($event)"
      >
      </app-entity-group>
    </ng-container>
  </ng-container>
</form>
